import { actionPanelStore } from 'src/stores/action-panel-store';

// ----------------------------------------------------------------------

/**
 * In-memory client work that a hard reload would destroy, so the auto-reload
 * on navigation must wait for it to finish.
 *
 * An allocation runs in a module-level MobX store and its GlobalActionPanel is
 * designed to survive route changes, so reloading mid-allocation would wipe the
 * progress/selection the user is watching. Add further "in-flight, a reload
 * would lose it" checks here as they arise.
 */
export function isReloadUnsafe(): boolean {
  return actionPanelStore.isAllocating;
}
